var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconModuleGiftCards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-module-gift-cards",
    transform: "translate(-32.243 -0.003)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5839",
    "data-name": "Rectangle 5839",
    width: 92,
    height: 92,
    transform: "translate(32.243 0.003)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "gift-cards",
    d: "M62.651,3.1H6.817A5.334,5.334,0,0,0,1.6,8.388v32.3a5.334,5.334,0,0,0,5.217,5.288H62.651a5.334,5.334,0,0,0,5.217-5.288V8.388A5.334,5.334,0,0,0,62.651,3.1Zm2.256,5.288V22.4H32.478a6.305,6.305,0,0,0,1.692-4.574,6.513,6.513,0,0,0-6.486-6.575,7.358,7.358,0,0,0-4.512,1.715V6.1H62.51A2.277,2.277,0,0,1,64.907,8.388Zm-50.9,10.434a3.666,3.666,0,0,1,3.666-3.716,3.581,3.581,0,0,1,3.666,3.716v3.716H17.674A3.757,3.757,0,0,1,14.008,18.822Zm9.306-1A4.512,4.512,0,1,1,27.825,22.4H23.313ZM6.817,6.1H21.2v8.147a5.476,5.476,0,0,0-3.666-1.286A5.811,5.811,0,0,0,13.162,22.4h-8.6V8.388A2.243,2.243,0,0,1,6.817,6.1ZM4.561,40.691V24.54H19.648l-4.089,4.145a1.133,1.133,0,0,0,0,1.572,1.012,1.012,0,0,0,1.41,0l4.089-4.145V43.264H6.817A2.72,2.72,0,0,1,4.561,40.691Zm58.09,2.287H23.313V25.826l5.922,6a1.012,1.012,0,0,0,1.41,0,1.133,1.133,0,0,0,0-1.572L24.864,24.4H64.907V40.548A2.281,2.281,0,0,1,62.651,42.978Z",
    transform: "translate(43.612 23.081)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModuleGiftCards);
export default __webpack_public_path__ + "static/media/icon-module-gift-cards.cdfe8618.svg";
export { ForwardRef as ReactComponent };